<ion-header>
  <ion-toolbar>
    <ion-title>Suscribir</ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-select
              [(ngModel)]="zone"
              placeholder="Zona"
              [compareWith]="zoneCompare"
              #B
              (ionChange)="selectZone(B.value)"
            >
              <ion-select-option [value]="z" *ngFor="let z of zones; let i = index">{{z.name}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div
    class="subscription-button"
    *ngFor="let sOption of subscriptionOptions"
    (click)="select(sOption)"
    [class.selected]="selected && sOption.id == selected.id"
  >
    <div [class]="'subscription-icon '+sOption.name.toLowerCase()">
      <ion-icon [src]="'/assets/icon/'+sOption.name.toLowerCase()+'.svg'"></ion-icon>
    </div>
    <p *ngIf="sOption.name.toLowerCase()==='sr'">
      Viaje
      <br />
      Redondo
    </p>
    <p *ngIf="sOption.name.toLowerCase()==='srf'">
      Viaje
      <br />
      Redondo Flex
    </p>
    <p *ngIf="sOption.name.toLowerCase()==='ss'">
      Medio
      <br />
      servicio
    </p>
    <p *ngIf="sOption.name.toLowerCase()==='ssf'">
      Medio
      <br />
      servicio Flex
    </p>
    <p *ngIf="sOption.name.toLowerCase() === 'pv'">
      Pago
      <br />
      por viaje
    </p>
    <p class="zone">{{zone.name}}</p>
    <p>${{sOption.price | number }}</p>
  </div>
</ion-content>

<ion-footer class="ion-padding">
  <ion-button shape="round" fill="outline" color="primary" expand="block" [disabled]="!selected" (click)="next()">
    Siguiente
  </ion-button>
</ion-footer>
